import React from "react";
import styles from "./ExcursionAccessibilityLevel.module.scss";
import commonStyles from "../commons.module.scss";
import clsx from "clsx";
import { Icon, IconName } from "../../Icon/Icon";

type ExcursionAccessibilityLevelProps = {
  title: string;
  code: string;
  icon: IconName | undefined;
  label: string | undefined;
  description: string | undefined;
  showDescription?: boolean;
  titleClassName?: string;
};

export const ExcursionAccessibilityLevel: React.FC<
  ExcursionAccessibilityLevelProps
> = ({
  icon,
  label,
  description,
  showDescription = false,
  titleClassName = undefined,
  title
}) => {
  return (
    <div
      className={clsx(commonStyles.boxContainer, styles.container, {
        [styles.withDescription]: showDescription
      })}
    >
      <div className={clsx(commonStyles.boxTitle, titleClassName)}>{title}</div>
      <div className={styles.body}>
        {icon && (
          <Icon
            name={icon as IconName}
            className={styles.icon}
            size="1.5x"
            padding={false}
          />
        )}
        <div className={commonStyles.boxLabel}>
          {label}
          {showDescription && description ? (
            <span className={styles.description}>
              <br />
              {description}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ExcursionAccessibilityLevel;
